import { api } from './client';
import type {
  AgreementParty, AgreementPartyCreateInput, AgreementPartyUpdateInput,
  Page, PartyRole, UUID, WriteResult,
} from './types';

export interface AgreementPartiesListParams {
  agreement_id?: UUID; person_id?: UUID; role?: PartyRole;
  include_deleted?: boolean; limit?: number; offset?: number;
  /** P41: a column key, '-' prefix to reverse (server-side). */
  sort?: string;
}
function qs(p: object): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) if (v !== undefined && v !== null && v !== '') u.set(k, String(v));
  return u.toString() ? `?${u}` : '';
}

async function writeWithMaker<T>(
  call: () => Promise<{ data: T; status: number; headers: Headers }>,
): Promise<WriteResult<T>> {
  const r = await call();
  return {
    entity: r.data,
    pending: r.headers.get('X-Change-Request-Status') === 'pending',
    changeRequestId: r.headers.get('X-Change-Request-Id'),
  };
}

export const agreementPartiesApi = {
  list:    (p: AgreementPartiesListParams = {}) => api.get<Page<AgreementParty>>(`/agreement-parties${qs(p)}`),
  get:     (id: UUID)                            => api.get<AgreementParty>(`/agreement-parties/${id}`),
  create:  (payload: AgreementPartyCreateInput)  => writeWithMaker(() => api.postMeta<AgreementParty>('/agreement-parties', payload)),
  update:  (id: UUID, p: AgreementPartyUpdateInput) => writeWithMaker(() => api.patchMeta<AgreementParty>(`/agreement-parties/${id}`, p)),
  delete:  (id: UUID)                            => writeWithMaker(() => api.deleteMeta<AgreementParty>(`/agreement-parties/${id}`)),
  restore: (id: UUID)                            => writeWithMaker(() => api.postMeta<AgreementParty>(`/agreement-parties/${id}/restore`)),
};
